import React, { useReducer, ReactNode } from 'react';
import Context from './index';
import reducerLang from './reducerLang';
import reducerDialog from './reducerDialog';
import { CHANGE_LANG, OPEN_DIALOG, CLOSE_DIALOG } from './types';

type langStateProps = {
	children: ReactNode;
};

const ContextState = ({ children }: langStateProps) => {
	const [stateLang, dispatchLang] = useReducer(reducerLang, {
		currentLang: 'IN',
	});

	const [stateDialog, dispatchDialog] = useReducer(reducerDialog, {
		open: false,
		title: '',
		text: '',
		handleAgree: () => {},
	});

	const changeLang = (lang: string) => {
		dispatchLang({
			type: CHANGE_LANG,
			payload: {
				lang,
			},
		});
		localStorage.setItem('lang', lang);
	};

	const getLang = () => {
		const lang = localStorage.getItem('lang');
		if (lang) {
			return lang;
		}
		return stateLang.currentLang;
	};

	const openDialog = (title: string, text: string, handleAgree: any) => {
		dispatchDialog({
			type: OPEN_DIALOG,
			payload: {
				open: true,
				title: title,
				text: text,
				handleAgree: handleAgree,
			},
		});
	};

	const closeDialog = () => {
		dispatchDialog({
			type: CLOSE_DIALOG,
			payload: {
				open: false,
				title: '',
				text: '',
				handleAgree: () => {},
			},
		});
	};

	return (
		<Context.Provider
			value={{
				getLang,
				changeLang,
				dialog: stateDialog,
				openDialog,
				closeDialog,
			}}
		>
			{children}
		</Context.Provider>
	);
};

export default ContextState;
